import type { Mission } from '../missions.ts'

export const fdic: Mission = {
  id: "fdic",
  name: "Federal Deposit Insurance Corporation",
  short: "FDIC",
  call: "Deposit Insurance",
  kind: "independent",
  community: "financial",
  url: "https://www.fdic.gov/",
  established: 1933,
  palette: {
    primary: "#003256",
    secondary: "#0a4b70",
    accent: "#b7ac83",
  },
  colorSource: {
    kind: "site",
    url: "https://www.fdic.gov/",
  },
  motif: "key",
  mission: {
    text: "The Federal Deposit Insurance Corporation (FDIC) is an independent agency created by Congress to maintain stability and public confidence in the nation's financial system.",
    url: "https://www.fdic.gov/about",
  },
  fact: {
    text: "Since FDIC insurance began in 1934, no depositor has lost a single penny of insured funds due to bank failure.",
    url: "https://www.fdic.gov/about",
  },
  seal: {
    file: "public/seals/fdic.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Federal_Deposit_Insurance_Corporation.svg",
  },
  logo: {
    file: "public/logos/fdic.svg",
    source: "https://commons.wikimedia.org/wiki/File:US-FDIC-Logo.svg",
  },
  identifier: {
    about: "https://www.fdic.gov/about",
    accessibility: "https://www.fdic.gov/about/fdic-accessibility-statement",
    foia: "https://www.fdic.gov/foia",
    noFear: "https://www.fdic.gov/about/no-fear-act",
    oig: "https://www.fdicoig.gov/",
    performance: "https://www.fdic.gov/strategic-plans",
    privacy: "https://www.fdic.gov/about/privacy-program",
  },
  media: {
    photos: [
      {
        file: "/media/fdic-dover-bank.jpg",
        small: "/media/fdic-dover-bank-sm.jpg",
        alt: "The domed First National Bank building on a street corner in Dover, Delaware",
        title: "Bank. Dover, Delaware",
        creator: "John Vachon, Farm Security Administration",
        source: "https://www.loc.gov/pictures/item/2017767899/",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/fdic-bank-steam.jpg",
        small: "/media/fdic-bank-steam-sm.jpg",
        alt: "Workers on a scaffold steam cleaning the ornate stone facade of a bank building",
        title: "Washington, D.C. Steam cleaning a bank building at 14th and G Streets, N.W.",
        creator: "John Ferrell, U.S. Office of War Information",
        source: "https://www.loc.gov/pictures/item/2017764315/",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
